export var actionTypes = {
  AUTH_SET_USER: 'AUTH_SET_USER',
  FORM_CLEAR_FIELD_ERRORS: 'FORM_CLEAR_FIELD_ERRORS',
  FORM_CLEAR_FIELD_VALUE: 'FORM_CLEAR_FIELD_VALUE',
  FORM_FULFILLED: 'FORM_FULFILLED',
  FORM_PENDING: 'FORM_PENDING',
  FORM_REGISTER: 'FORM_REGISTER',
  FORM_REJECTED: 'FORM_REJECTED',
  FORM_RESET: 'FORM_RESET',
  FORM_SET_FIELD_ERRORS: 'FORM_SET_FIELD_ERRORS',
  FORM_SET_FIELD_VALUE: 'FORM_SET_FIELD_VALUE',
  FORM_SET_FIELD_VALUES: 'FORM_SET_FIELD_VALUES',
  FORM_UNREGISTER: 'FORM_UNREGISTER',
  OVERLAY_CLOSE: 'OVERLAY_CLOSE',
  OVERLAY_CLOSE_ALL: 'OVERLAY_CLOSE_ALL',
  OVERLAY_OPEN: 'OVERLAY_OPEN',
  ROUTER_UPDATE: 'ROUTER_UPDATE',
  SERVICE_CLEAR_PARAM_VALUE: 'SERVICE_CLEAR_PARAM_VALUE',
  SERVICE_FULFILLED: 'SERVICE_FULFILLED',
  SERVICE_PENDING: 'SERVICE_PENDING',
  SERVICE_REGISTER: 'SERVICE_REGISTER',
  SERVICE_REJECTED: 'SERVICE_REJECTED',
  SERVICE_RESET: 'SERVICE_RESET',
  SERVICE_SET_PARAM_VALUE: 'SERVICE_SET_PARAM_VALUE',
  SERVICE_SET_PARAM_VALUES: 'SERVICE_SET_PARAM_VALUES',
  SERVICE_UNREGISTER: 'SERVICE_UNREGISTER'
};